import React from 'react';
import { Button } from './button';
import { Popover, PopoverContent, PopoverTrigger } from './popover';
import { CalendarIcon } from 'lucide-react';
import { format } from 'date-fns';
import { vi } from 'date-fns/locale';

interface DateRangePickerProps {
  className?: string;
  value?: { from?: Date; to?: Date };
  onChange?: (range: { from?: Date; to?: Date }) => void;
}

export function DatePickerWithRange({ className, value, onChange }: DateRangePickerProps) {
  return (
    <div className={className}>
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" className="w-[260px] justify-start text-left font-normal">
            <CalendarIcon className="mr-2 h-4 w-4" />
            {value?.from ? (
              value.to ? (
                <>
                  {format(value.from, "P", { locale: vi })} -{" "}
                  {format(value.to, "P", { locale: vi })}
                </>
              ) : (
                format(value.from, "P", { locale: vi })
              )
            ) : (
              <span>Chọn thời gian</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-4" align="start">
          <p className="text-sm text-slate-500">Calendar component sẽ được tích hợp ở đây.</p>
        </PopoverContent>
      </Popover>
    </div>
  );
}
